import { useNavigation } from 'react-router';

export default function useIsNavigating() {
  const navigation = useNavigation();
  return Boolean(navigation.location) || navigation.state === 'loading';
}
